<template>
<div class="password-page">
  <h2>{{ $t('修改密码') }}</h2>
  <el-button type="primary" icon="el-icon-lock" @click="visible = true">{{ $t('修改密码') }}</el-button>
  <password :visible="visible" @close="visible = false" />
</div>
</template>

<script>
import Password from '@/views/system/profile/component/Password.vue'

export default {
  name: 'CustomerPassword',
  components: { Password },
  data () { return { visible: false } }
}
</script>

<style scoped>
.password-page { padding: 24px; }
.password-page h2 { font-size: 20px; margin: 0 0 20px; }
</style>
